var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.2104V17.3157",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36836 16.2104C7.47839 18.3712 7.59363 19.5053 8.39856 20.2223C9.27143 20.9999 10.633 20.9999 13.3561 20.9999H14.6439C17.3669 20.9999 18.7285 20.9999 19.6013 20.2223C20.4063 19.5053 20.5215 18.3712 20.6315 16.2104",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25582 12.8527C8.50793 15.2337 11.332 16.2104 14 16.2104C16.668 16.2104 19.4921 15.2337 20.7442 12.8527C21.3419 11.7161 20.8893 9.57886 19.4173 9.57886H8.58274C7.1107 9.57886 6.65813 11.7161 7.25582 12.8527Z",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9473 9.57895L16.8822 9.35122C16.558 8.21645 16.3959 7.64906 16.01 7.32453C15.624 7 15.1114 7 14.0861 7H13.9137C12.8885 7 12.3758 7 11.9899 7.32453C11.6039 7.64906 11.4418 8.21645 11.1176 9.35122L11.0525 9.57895",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/business_icon.5c4bb910a49653906d0b13257441c783.svg";
export { ForwardRef as ReactComponent };